import axios from 'axios';
import { useState, useEffect} from 'react';
import SingleContent from '../../Components/SingleContent/SingleContent';
import "./Trending.css";
import CustomPagination from '../../Components/Pagination/CustomPagination';

const Trending = () => {
//Setting a usestate
const [page , setPage] = useState(1);
const [content , setContent] = useState([]);

const fetchTrending = async() =>{
    const {data} = await axios.get(`https://api.themoviedb.org/3/trending/all/day?api_key=2c629ca30095712591ced9ffe3cd649c&page=${page}`);
    
    
        console.log(data);
        setContent(data.results);

};
useEffect(() =>{
 fetchTrending()
  // eslint-disable-next-line 
},[page]);

    return (
        <div className = 'trending'>
           <span className = 'pageTitle'>Trending Movie & TV Series</span> 
           <div className = 'trending'>
               {content && content.map((c) =>(
                <SingleContent
                 key ={c.id}
                  id= {c.id}
                   poster = {c.poster_path}
                    title = {c.title|| c.name} 
                    date= {c.first_air_date||c.release_date}
                    media_type = {c.media_type}
                    vote_average = {c.vote_average} /> 
               ))}
           </div>
           <CustomPagination setPage = {setPage}/>
        </div>
    )
};
export default Trending